import React from 'react';
import webapi from '../../../api/webapi';
import Header from '../Header/Header'
import Footer from '../Footer/Footer'


class Library_RelatedArticles extends React.Component {
    state = { statments : [] }

    constructor(props, context) {
        super(props, context);
        this.state = {
            pageData: undefined
        };
    }
    
    componentDidMount() {
        //fetch('https://api.ipify.org/?format=json')
        fetch('https://geolocation-db.com/json/')
            .then(response => {
                return response.json();
            }, "jsonp")
            .then(res => {
                this.setLog('pages/log/Library_RelatedArticles/visit/'+res.IPv4.replaceAll('.',','))
            })
            .catch(err => this.setLog('pages/log/Library_RelatedArticles/visit/'+err));
        this.getPage();
    }
    
    async setLog(Data) {
        await webapi.post(Data);
    }
    
    async getPage() {
        const pageList = await webapi.get('pages/htmlpages/10203');   
        //console.log(pageList);     
        this.setState({
            pageData: pageList.data
        });
    }
    
    render() {
        if (this.state.pageData) {
            return  (
                <div>
                    <Header ActiveButton='Library'/>
                    <div className="container-fluid" id="innerpage_row_1">
                        <div className="container">
                            <h1 id="page_title">مقالات مرتبط</h1>
                        </div>
                    </div>
                    
                    <div className="container-fluid">
                        <div className="container container_70">
                            {
                                this.state.pageData.map((HtmlParagraph) =>{  
                                    return(
                                        HtmlParagraph != null 
                                        ?
                                        (
                                            <div>
                                               <section
                                                    className="data-title"
                                                    dangerouslySetInnerHTML={{ __html:HtmlParagraph.Key}}  
                                                />
                                                <section
                                                    className="data-body"
                                                    dangerouslySetInnerHTML={{ __html:HtmlParagraph.Value}}  
                                                />
                                                <br />
                                            </div>
                                        )
                                        :
                                        (
                                            null
                                        )
                                    )
                                })
                            } 
                        </div>
                    </div>
                    <Footer />
                </div>  
            );
        } else {
            return  (
                        <div></div>
                    )
        }
    }
 }

 export default Library_RelatedArticles;